import { DashboardTrackingModalComponent } from './../../shared/dashboard-tracking-modal/dashboard-tracking-modal.component';
import { map, filter } from 'rxjs/operators';
import { DashboardService } from './../services/dashboard.service';
import { Component, OnInit, Input } from '@angular/core';
// import { Chart, ChartModule, MapChart } from 'angular-highcharts';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import * as highcharts from 'Highcharts';

// import * as Highcharts from 'highcharts';
// import HC_map from 'highcharts/modules/map';
// HC_map(Highcharts);
// import * as collection from '../../../../node_modules/@highcharts/map-collection';
import { FEATURES } from '../../config/worldmap';
import { DashboardModalComponent } from '../../shared/dashboard-modal/dashboard-modal.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {


  // fileNameDialogRef: MatDialogRef<DashboardModalComponent>;

  constructor(public dashboardService: DashboardService, public dialog: MatDialog) { }

  public chart: any;
  public barchart: any;
  public solidgauge: any;
  public lineChart: any;


  Highcharts:any = null;
  public barChartsWithlabel: any;
  public worldMap: any;
  public totalImplantStock: any;
  public totalImplantStockName: any;
  public BodypartCountId: any;
  public totalImplantStockPer: any;
  public bodyPartCount: any;
  public bodyPartCountTitle: any;
  public orderUsage: any;
  @Input() public getBodyPartdata: any;
  public dashboardArrivedNotification: any;
  public dashboardConsumedNotification: any;
  public dashboardStatus: any;
  public dashboardConsumedStatus: any;
  public productUsed: any;
  public productUsedTitle: any;
  public today: number = Date.now();
  public dashboardHeader: any;
  public token: string;
  public dashboardPermission = false;
  public totalOrdersPermission = false;
  public availableStockPermission = false;
  public totalConsumedPermission = false;
  public pendingPermission = false;
  public todayStockPermission = false;
  public notificationPermission = false;
  public implantCategoriesPermission = false;
  public productsUsedPermission = false;
  public orderStockPermission = false;
  public cityPermission = false;
  public yearlyUsageTitle : any;
  public yearlyUsageMonth : any;
  public yearlyUsageData :any;

  public links: {
    'purchase': '/home/purchase-order',
    'stocks': '/home/stocks'
    'consumed': '/home/used_implants'
    'rejected': '/home/rejected_implants'
  };

  refreshDashboard() {
    this.getStocks();
    this.init();
    this.getNotification();
    this.getDashBoardHeader();
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      this.dashboardPermission = true;
      this.totalOrdersPermission = true;
      this.availableStockPermission = true;
      this.totalConsumedPermission = true;
      this.pendingPermission = true;
      this.todayStockPermission = true;
      this.notificationPermission = true;
      this.implantCategoriesPermission = true;
      this.productsUsedPermission = true;
      this.orderStockPermission = true;
      this.cityPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:max-line-length triple-equals
      if (roles['dashboard.total_orders'] == 1 || roles['dashboard.available_stock'] == 1 || roles['dashboard.total_consumed'] == 1 || roles['dashboard.pending'] == 1
        // tslint:disable-next-line:triple-equals max-line-length
        || roles['dashboard.today_stock'] == 1 || roles['dashboard.notification'] == 1 || roles['dashboard.implant_categories'] == 1 || roles['ashboard.products_used'] == 1
        // tslint:disable-next-line:triple-equals
        || roles['dashboard.order_stock'] == 1 || roles['dashboard.city'] == 1) {
          this.dashboardPermission = true;
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.total_orders'] == 1) {
            this.totalOrdersPermission = true;
          }
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.available_stock'] == 1) {
            this.availableStockPermission = true;
          }
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.total_consumed'] == 1) {
            this.totalConsumedPermission = true;
          }
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.pending'] == 1) {
            this.pendingPermission = true;
          }
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.today_stock'] == 1) {
            this.todayStockPermission = true;
          }
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.notification'] == 1) {
            this.notificationPermission = true;
          }
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.implant_categories'] == 1) {
            this.implantCategoriesPermission = true;
          }
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.products_used'] == 1) {
            this.productsUsedPermission = true;
          }
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.order_stock'] == 1) {
            this.orderStockPermission = true;
          }
          // tslint:disable-next-line:triple-equals
          if (roles['dashboard.products_used'] == 1) {
            this.cityPermission = true;
          }
      }
    }
    this.token = localStorage.getItem('token');
    this.getStocks();
    this.init();
    this.getNotification();
    this.getDashBoardHeader();
  }

  getStocks() {
    this.dashboardService.getDashBoard().subscribe(res => {
      this.totalImplantStock = res.data.totalImplantsStock;
      this.orderUsage = res.data.orderUsage;
      // tslint:disable-next-line:no-shadowed-variable
      this.totalImplantStockName = res.data.totalImplantsStock.data.map(res => {
        // tslint:disable-next-line:prefer-const
        let { name, count } = res;
        count = parseInt(count, 10);
        return [name, count];
      });
      // tslint:disable-next-line:no-shadowed-variable
      this.BodypartCountId = res.data.BodypartCount.data.map(res => res.id);
      this.bodyPartCountTitle = res.data.BodypartCount.title;
      // tslint:disable-next-line:no-shadowed-variable
      this.bodyPartCount = res.data.BodypartCount.data.map(res => {
        // tslint:disable-next-line:prefer-const
        let { name, count, color } = res;
        count = parseInt(count, 10);
        return [name, count, color];
      });
      this.productUsedTitle = res.data.productsUsed.title;
      // tslint:disable-next-line:no-shadowed-variable
      this.productUsed = res.data.productsUsed.data.map(res => {
        // tslint:disable-next-line:prefer-const
        let { name, count } = res;
        count = parseInt(count, 10);
        return [name, count];
      });

      this.yearlyUsageTitle = res.data.yearlyUsage.title;
      this.yearlyUsageData = res.data.yearlyUsage.data.map(res => {
        // tslint:disable-next-line:prefer-const
        let { quantity} = res;
        quantity = parseInt(quantity, 10);
        return [quantity];
      });
      this.yearlyUsageMonth = res.data.yearlyUsage.data.map(res => {
        // tslint:disable-next-line:prefer-const
        let { month} = res;        
        return [month];
      });

      this.getPieChart();
      // this.getColumnChart();
      this.getSolidGauge();
      this.getSimpleBarChart();
      this.getComplexBarChart();
      this.getMultipleColumnChart();
      this.getLineChart();

    });
  }

  getDashBoardHeader() {
    const iconslinks = [
      'fa fa-shopping-bag',
      'fa fa-bar-chart',
      'fa fa-users',
      'fa fa-hourglass-half'
    ];

    this.dashboardService.getDashBoard().subscribe(res => {
      this.dashboardHeader = res.data.dashboardHeader.data;
      this.dashboardHeader[0] = Object.assign(this.dashboardHeader[0], {
        links: '/home/purchase-order',
        permission: this.totalOrdersPermission
      });
      this.dashboardHeader[1] = Object.assign(this.dashboardHeader[1], {
        links: '/home/stocks',
        permission: this.availableStockPermission
      });
      this.dashboardHeader[2] = Object.assign(this.dashboardHeader[2], {
        links: '/home/used-implants',
        permission: this.totalConsumedPermission
      });
      this.dashboardHeader[3] = Object.assign(this.dashboardHeader[3], {
        links: '/home/rejected-implants',
        permission: this.pendingPermission
      });
      for (let i = 0; i < this.dashboardHeader.length; i++) {
        this.dashboardHeader[i] = Object.assign(this.dashboardHeader[i], {
          icon: iconslinks[i]
        });
      }
    });
  }

  getNotification() {
    this.dashboardService.getDashBoard().subscribe(res => {
      this.dashboardArrivedNotification = res.data.notificationArrived.data;
      this.dashboardStatus = res.data.notificationArrived.status;
      this.dashboardConsumedNotification = res.data.notificationUsed.data;
      this.dashboardConsumedStatus = res.data.notificationUsed.status;
    });
  }

  getPieChart() {
    // this.chart = new Chart({
    //   chart: {
    //     type: 'pie',
    //     borderColor : '#CFD9F2',
    //     borderWidth: 1,
    //     borderRadius: 2
    //   },
    //   accessibility: {
    //     enabled: false
    //   },

    //   title: {
    //     text: this.totalImplantStock.title + ' (%)'
    //   },
    //   credits: {
    //     enabled: false
    //   },
    //   series: [{
    //     type: 'pie',
    //     name: '',
    //     data: this.totalImplantStockName
    //   }]
    // });
  }

  getLineChart(){
    //     this.lineChart = new Chart({
    //   chart: {
    //     type: 'line',
    //     borderColor : '#CFD9F2',
    //     borderWidth: 1,
    //     borderRadius: 2
    //   },
    //   title: {
    //     text: this.yearlyUsageTitle
    //   },

    //   xAxis: {
    //     title: {
    //       text: 'Body Parts'
    //     },
    //     categories: this.yearlyUsageMonth
    //   },

    //   yAxis: {
    //     title: {
    //       text: 'Quantity'
    //     }
    //   },

    //   credits: {
    //     enabled: false
    //   },
    //   series: [{
    //     type: 'line',
    //     name: 'Knee',
    //     data: this.yearlyUsageData 
    //   }/*,
    //   {
    //     type: 'line',
    //     name: 'Hip',
    //     data: [34, 28, 51, 11, 17, 22, 24]
    //   }, {
    //     type: 'line',
    //     name: 'Shoulder',
    //     data: [39, 12, 41, 71, 37, 72, 14]
    //   }*/]
    // });
  }

  getSolidGauge() {
    // this.solidgauge = new Chart({
    //   chart: {
    //     type: 'solidgauge',
    //     borderColor : '#CFD9F2',
    //     borderWidth: 1,
    //     borderRadius: 2

    // },
    //   title: {
    //     text: this.orderUsage.title
    //   },
    //   pane: {
    //     center: ['50%', '85%'],
    //     size: '140%',
    //     startAngle: -90,
    //     endAngle: 90,
    //     background: {
    //       backgroundColor: '#EEE',
    //       innerRadius: '60%',
    //       outerRadius: '100%',
    //       shape: 'arc'
    //     }
    //   },
    //   tooltip: { enabled: false },
    //   yAxis: {
    //     stops: [[0.1, '#55BF3B'], [0.5, '#DDDF0D'], [0.9, '#DF5353']],
    //     lineWidth: 0,
    //     minorTickInterval: null,
    //     tickAmount: 2,
    //     // title: { y: -70, text: "Speed" },
    //     labels: { y: 16 },
    //     min: 0,
    //     max: 100,
    //     // title: {
    //     //   text: 'Stocks'
    //     // }
    //   },
    //   plotOptions: {
    //     solidgauge: { dataLabels: { y: 5, borderWidth: 0, useHTML: true } }
    //   },
    //   credits: { enabled: false },
    //   series: [
    //     {
    //       name: 'Stocks based on Body Implant Categories',
    //       data: [this.orderUsage.data],
    //       dataLabels: {
    //         format:
    //           '<div style="text-align:center"><span style="font-size:25px">{y}</span><br/></div>'
    //       },
    //       // tooltip: { valueSuffix: " km/h" }
    //     }
    //   ]
    // } as any);
  }

  openDialog(): any {
    const dialogRef = this.dialog.open(DashboardModalComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      // width: '1200px',
      // height: '62vh',
      disableClose: true
    });
  }

  openStockDialog(id): any {
    const chartData = id.point.name;
    this.dashboardService.getDashBoardById().subscribe(res => {
      this.getBodyPartdata = res.data;

      const dialogRef = this.dialog.open(DashboardModalComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        width: '1200px',
        disableClose: true,
        data: {
          res: this.getBodyPartdata,
          name: chartData
        }
      });
    });

  }

  openTrackingModal(prodId): any {
    this.dashboardService.getDisplacementDetails(prodId).subscribe(res => {
      const dialogRef = this.dialog.open(DashboardTrackingModalComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',       
         disableClose: true,
        data: res
      });
    });
  }

  getSimpleBarChart() {
    // this.barChartsWithlabel = new Chart({
    //   chart: {
    //     type: 'column',
    //     borderColor : '#CFD9F2',
    //     borderWidth: 1,
    //     borderRadius: 2
    //   },
    //   credits: {
    //     enabled: false
    //   },
    //   title: {
    //     text: this.bodyPartCountTitle
    //   },

    //   xAxis: {
    //     type: 'category',
    //     labels: {
    //       rotation: -45,
    //       style: {
    //         fontSize: '13px',
    //         fontFamily: 'Noto Sans, sans-serif'
    //       }
    //     },
    //   },
    //   yAxis: {
    //     min: 0,
    //     title: {
    //       text: 'Qunatity'
    //     }
    //   },

    //   tooltip: {
    //     split: true,


    //   },

    //   plotOptions: {
    //     series: {
    //       cursor: 'pointer',
    //       point: {
    //         events: {
    //           click: this.openStockDialog.bind(this)
    //         }
    //       }
    //     }
    //   },

    //   series: [
    //     {
    //       type: 'column',
    //       name: 'Count',
    //       data: this.bodyPartCount
    //     }

    //   ],


    // });
  }

  getComplexBarChart() {
    // this.barchart = new Chart({
    //   chart: {
    //     type: 'column',
    //     borderColor : '#CFD9F2',
    //     borderWidth: 1,
    //     borderRadius: 2
    //   },
    //   credits: {
    //     enabled: false
    //   },
    //   title: {
    //     text: 'Total Stocks'
    //   },
    //   legend: {
    //     layout: 'horizontal',
    //     x: 250,
    //     y: 100,
    //     floating: true,
    //     borderWidth: 1

    //   },
    //   xAxis: {
    //     categories: ['Jan', 'feb', 'March', 'April', 'May', 'June', 'july', 'Aug', 'Sept'], title: { text: 'Body parts' }
    //   },
    //   yAxis: {
    //     min: 0,
    //     title: {
    //       text: 'Product Name'
    //     },
    //     labels: {
    //       overflow: 'justify'
    //     }
    //   },

    //   plotOptions: {
    //     series: {
    //       cursor: 'pointer',
    //       point: {
    //         events: {
    //           click: this.openDialog.bind(this)
    //         }
    //       }
    //     }
    //   }
    // });
  }

  getMultipleColumnChart() {
    // this.barchart = new Chart({
    //   chart: {
    //     type: 'column',
    //     borderColor : '#CFD9F2',
    //     borderWidth: 1,
    //     borderRadius: 2
    //   },
    //   credits: {
    //     enabled: false
    //   },
    //   title: {
    //     text: this.productUsedTitle
    //   },
    //   legend: {
    //     layout: 'horizontal',
    //     x: 250,
    //     y: 100,
    //     floating: true,
    //     borderWidth: 1

    //   },
    //   xAxis: {
    //     type: 'category',
    //     title: { text: 'Body Implants' }
    //   },
    //   yAxis: {
    //     min: 0,
    //     title: {
    //       text: 'Quantity'
    //     },
    //     labels: {
    //       overflow: 'justify'
    //     }
    //   },
    //   series: [
    //     {
    //       type: 'column',
    //       name: 'Body Part Implant',
    //       data: this.productUsed
    //     }
    //   ]
    // });
  }



  init() {
    // this.barchart = new Chart({
    //   chart: {
    //     type: 'column',
    //     borderColor : '#CFD9F2',
    //     borderWidth: 1,
    //     borderRadius: 2
    //   },
    //   credits: {
    //     enabled: false
    //   },
    //   title: {
    //     text: 'Total Stocks'
    //   },
    //   legend: {
    //     layout: 'horizontal',
    //     x: 250,
    //     y: 100,
    //     floating: true,
    //     borderWidth: 1

    //   },
    //   xAxis: {
    //     categories: ['Jan', 'feb', 'March', 'April', 'May', 'June', 'july', 'Aug', 'Sept'], title: { text: 'Body parts' }
    //   },
    //   yAxis: {
    //     min: 0,
    //     title: {
    //       text: 'Product Name'
    //     },
    //     labels: {
    //       overflow: 'justify'
    //     }
    //   },

    //   plotOptions: {
    //     series: {
    //       cursor: 'pointer',
    //       point: {
    //         events: {
    //           click: this.openDialog.bind(this)
    //         }
    //       }
    //     }
    //   }
    // });



    // this.barChartsWithlabel = new Chart({
    //   chart: {
    //     type: 'column'
    //   },
    //   credits: {
    //     enabled: false
    //   },
    //   title: {
    //     text: 'Implant consumed based on billing cycle'
    //   },

    //   xAxis: {
    //     type: 'category',
    //     labels: {
    //       rotation: -45,
    //       style: {
    //         fontSize: '13px',
    //         fontFamily: 'Noto Sans, sans-serif'
    //       }
    //     }
    //   },
    //   yAxis: {
    //     min: 0,
    //     title: {
    //       text: 'Qunatity'
    //     }
    //   }


    // });

    // this.worldMap = new MapChart({
    //   chart: {
    //     // borderWidth: 1,
    //     map: FEATURES,
    //     borderColor : '#CFD9F2',
    //     borderWidth: 1,
    //     borderRadius: 2
    //   },
    //   credits: {
    //     enabled: false
    //   },
    //   title: {
    //     text: 'City'
    //   },
    //   plotOptions: {
    //     map: {
    //       allAreas: true
    //     }
    //   },
    //   mapNavigation: {
    //     enabled: true,
    //     buttonOptions: {
    //       verticalAlign: 'bottom'
    //     }
    //   },
    //   series: [
    //     {
    //        name: 'Map'
    //       // color: "red"
    //       // mapData: Highcharts.maps['custom/world'] <- MOVED TO chart.map
    //     },
    //     {
    //       type: 'mapbubble',
    //       name: 'Warehouses',
    //       joinBy: null,
    //       data: [
    //         {
    //           x: 10,
    //           z: 12
    //         }
    //       ],
    //       minSize: 20,
    //       maxSize: '10%'
    //     }
    //   ] as any
    // });
  }


}
